import { Skeleton, Stack, Typography } from '@mui/material';

import { SharedEndpointIconSize } from '@/sections/SharedEndpoints/Icons/types';
import { mapModelFamilyToIcon } from '@/sections/SharedEndpoints/utils';
import { pluralizeString } from '@/utils/pluralizeString';

import { useOrgSharedEndpointsInferenceVolume } from '../../ModelAPIs/hooks';
import { ListItem } from '../styled';
import { CardProps } from './types';

function Card({ orgSharedEndpoint }: CardProps) {
  const { data: inferenceVolumeData, loading: inferenceVolumeLoading } =
    useOrgSharedEndpointsInferenceVolume(orgSharedEndpoint.id);
  const Icon = mapModelFamilyToIcon(orgSharedEndpoint.sharedEndpoint.modelFamily);

  return (
    <ListItem key={orgSharedEndpoint.id}>
      <Stack gap={2} direction="row" alignItems="center">
        <Icon size={SharedEndpointIconSize.MEDIUM} />
        <Typography variant="h5">{orgSharedEndpoint.sharedEndpoint.name}</Typography>
      </Stack>
      <Stack direction="row" gap={1} alignItems="center" minHeight={25}>
        {inferenceVolumeLoading && !inferenceVolumeData ? (
          <Skeleton variant="text" width={100} height={20} />
        ) : (
          <>
            <Typography variant="h5">
              {inferenceVolumeData?.instantSharedEndpointsMetrics.inferenceVolume || 0}
            </Typography>
            <Typography variant="body1" color="text.muted">
              {pluralizeString(
                inferenceVolumeData?.instantSharedEndpointsMetrics.inferenceVolume || 0,
                'request',
                undefined,
                undefined,
                false,
              )}{' '}
              /hour
            </Typography>
          </>
        )}
      </Stack>
    </ListItem>
  );
}

export default Card;
